"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeCardSidebar = void 0;
const ui_1 = require("@app/component/ui");
const builder_1 = require("@app/util/builders/builder");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const employee_card_context_1 = require("../util/employee-card-context");
const EmployeeCardSidebar = () => {
    const { selectedTab, setSelectedTab, employeeCardTabs } = (0, employee_card_context_1.useEmployeeCard)();
    const isSelected = (tabId) => selectedTab === tabId;
    return (react_1.default.createElement("div", { className: 'ds-ec-sidebar' },
        react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.BOTH, size: ui_1.Spacing.SIZES.SIZE_6 },
            react_1.default.createElement("div", { className: 'ds-ec-sidebar-nav' },
                react_1.default.createElement(builder_1.Builder, { getKey: (el) => el.id, elements: employeeCardTabs.filter(t => t.isVisible) }, (el) => (react_1.default.createElement("div", { "data-testid": el.id + '-nav-item', className: (0, classnames_1.default)('ds-nav-item', { selected: isSelected(el.id) }), onClick: () => setSelectedTab(el.id) },
                    react_1.default.createElement(ui_1.Icon, { size: ui_1.Icon.SIZES.SMALL, ico: el.icon }),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement(ui_1.Text, { weight: isSelected(el.id) ? 'bold' : 'medium', color: 'inherit', type: ui_1.Text.TYPES.BODY_LARGE }, el.label))))))));
};
exports.EmployeeCardSidebar = EmployeeCardSidebar;
